<template>
  <div class="mt-3 ml-5 mr-5">
    <CRow class="align-items-center">
      <CCol class="ml-2" sm="8">
        <h2 class="text-white font-weight-bolder m-0">MFU Courses</h2>
      </CCol>
      <CCol sm="3">
        <small
          v-if="registerCourses.length > limitViewAll"
          class="text-white text-right font-weight-light m-0"
        >
          View all
        </small>
      </CCol>
    </CRow>
    <div class="container-card mt-2 ml-2 position-relative">
      <a
        v-show="checkWidth()"
        class="left"
        id="left-button-free"
        @click="swipeLeft"
        v-if="registerCourses[0].courses.length >= limitSlider"
      >
        <font-awesome-icon :icon="['fas', 'angle-left']" class="arrow" />
      </a>
      <div class="wrapper mt-2 p-4" id="content-free" ref="contentFree">
        <div
          v-for="(item, index) in registerCourses[0].courses"
          :key="index"
          class="mr-2"
        >
          <div
            :class="[
              'animatedBox',
              { active: selectedIndexCard.includes(index) },
            ]"
          >
            <mdlCard
              type="normal"
              :data="item.courseinfo"
              :index="index"
              :backgroundIMG="item.courseinfo.style.background[0]"
            />
          </div>
        </div>
      </div>
      <a
        v-show="checkWidth()"
        class="right"
        id="right-button"
        @click="swipeRight"
        v-if="registerCourses[0].courses.length >= limitSlider"
      >
        <font-awesome-icon :icon="['fas', 'angle-right']" class="arrow" />
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import mdlCard from "../../showSingleCard/MdlCard";

export default {
  name: "index",
  props: {
    registerCourses: Array,
  },
  data() {
    return {
      limitViewAll: 20,
      limitSlider: 7,
      signalForAnimated: false,
      selectedIndexCard: [],
      animationTesting: false,
      CheckWidth: window.innerWidth.toString(),
    };
  },
  components: {
    mdlCard,
  },
  methods: {
    checkWidth() {
      if (this.CheckWidth <= 375) {
        return false;
      }
      return true;
    },
    swipeLeft() {
      const content = this.$refs.contentFree;
      this.scrollTo(content, -300, 800);
    },
    swipeRight() {
      const content = this.$refs.contentFree;
      this.scrollTo(content, 300, 800);
    },
    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft;
      // alert((element.clientWidth + scrollPos) + " == " + element.scrollWidth + " == "+scrollPos)
      // Condition to check if scrolling is required
      if (
        !(
          (scrollPos === 0 || scrollPixels > 0) &&
          (element.clientWidth + scrollPos === element.scrollWidth ||
            scrollPixels < 0)
        )
      ) {
        // Get the start timestamp

        const startTime =
          "now" in window.performance
            ? performance.now()
            : new Date().getTime();

        function scroll(timestamp) {
          //Calculate the timeelapsed
          const timeElapsed = timestamp - startTime;
          //Calculate progress
          const progress = Math.min(timeElapsed / duration, 1);
          //Set the scrolleft
          element.scrollLeft = scrollPos + scrollPixels * progress;
          //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
          if (timeElapsed < duration) {
            //Request for animation
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        }
        //Call requestAnimationFrame on scroll function first time
        window.requestAnimationFrame(scroll);
      }
    },
  },
};
</script>

<style scoped>
.animatedBox {
  cursor: pointer;
  /* margin-right: 3px; */
  transition: margin 0.4s ease-out;
}

.animatedBox.active {
  margin-right: 0.8rem;
}
.viewAllImage {
  border-radius: 50%;
  opacity: 0.8;
  vertical-align: center;
}
/* container for store cards */
.container-card {
  position: relative;
  width: 100%;
  height: auto;
  padding: 0;
}

.container-card .wrapper {
  width: auto;
  margin: 1px;
  overflow: hidden;
  white-space: nowrap;
  display: -webkit-box;
  display: -ms-flexbox;
  overflow-x: auto;
}

.container-card .wrapper .viewAllIconContainer {
  text-align: center;
  /* height: 220px; */
  /* line-height: 220px; */
  line-height: 17rem;
}

.container-card .wrapper .viewAllIconContainer img {
  vertical-align: middle;
}

.container-card .wrapper .viewAllIconContainer:hover {
  cursor: pointer;
}

.container-card .wrapper::-webkit-scrollbar {
  display: none;
}

.container-card .wrapper .itemC {
  /* height: 100%; */
  bottom: 0;
  display: inline-block;
}

.container-card .left {
  text-align: center;
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 3%;
  height: 100%;
  color: white;
  background: black;
  opacity: 0.3;
}
.arrow {
  object-fit: cover;
  height: 80%;
  width: 80%;
}
.container-card .right {
  text-align: center;
  z-index: 1;
  position: absolute;
  right: 0;
  width: 3%;
  top: 0;
  height: 100%;
  color: white;
  background: black;
  opacity: 0.2;
}

.container-card .left:hover,
.container-card .right:hover {
  cursor: pointer;
  opacity: 0.6;
  background: grey;
  height: 105%;
}

@media only screen and (max-width: 600px) {
  .container-card {
    position: relative;
    width: 100%;
    height: 280px;
  }

  .container-card .left {
    width: 7%;
  }

  .container-card .right {
    width: 7%;
  }
}
.viewAllText {
  /* padding-top: 0.5rem; */
  margin-top: auto;
  margin-bottom: -0.5rem !important;
}
.viewAllText:hover {
  cursor: pointer;
  /* padding-top: 0.5rem */
}
.topicText {
  margin-left: 3.5rem;
  padding-left: 0.35rem;
  text-align: left;
  font: Bold 30px/39px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  font-family: Roboto;
  font-weight: bold;
  margin-bottom: -1.5rem !important;
}
</style>
